import { RequestService } from '../../../../../common/services/RequestService';
import { GET_FILTER_ORDERS } from '../constants';
import {
  dataAdjustmentResponse,
  dataAdjustmentFiltersRequest,
} from './dataAdjustment';

export const getFilterOrdersRequest = async (profileId, filters) => {
  const response = await RequestService.get(
    GET_FILTER_ORDERS.replace('{profile_id}', profileId),
    {
      params: dataAdjustmentFiltersRequest(filters),
    }
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(order => dataAdjustmentResponse(order))
  );
};
